import React, { useEffect } from "react";
import { BrowserRouter, Route, Switch, useRouteMatch } from "react-router-dom";
import "./scss/style.scss";
import { createBrowserHistory } from "history";
import { getQueryParams, callBackUrl } from "src/utils/helper";
import { useDispatch } from "src/store";
import { REFRESH_TOKEN } from "src/variable/constant";
import localStorage from "src/utils/localStorage";
import { receiveToken } from "./redux/slices/setting";

const history = createBrowserHistory();

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const TheLayout = React.lazy(() => import("./containers/TheLayout"));

const App = () => {
  const dispatch = useDispatch();
  const match = useRouteMatch();
  const isAuthenticated = false;
  const url = window.location.href;
  const decodeURI = decodeURIComponent(url);
  const check = getQueryParams(decodeURI);
  const _pUrl = url.substring(url.lastIndexOf("/") + 1);

  useEffect(() => {
    checkTokenFromLocaleStorage();
  }, []);

  const applyToken = (token) => {
    localStorage.setItem(REFRESH_TOKEN, token);
    dispatch(receiveToken(token));
  };

  const removeTokenFromRoute = (callbackUrl = "") => {
    if (callbackUrl) {
      history.replace(`/chat/${callbackUrl}`);
      return;
    }
    history.replace(match.path);
  };

  const checkTokenFromLocaleStorage = () => {
    if (!isAuthenticated) {
      return checkCallBackURL();
    }
  };

  const checkCallBackURL = async () => {
    if (!check?.token) {
      let queryURL = "";
      if (_pUrl) {
        queryURL = `?callbackUrl=${_pUrl}`;
      }
      window.location.href = callBackUrl(queryURL);
      return;
    }
    applyToken(check?.token);
    removeTokenFromRoute(check?.callbackUrl);
  };

  return (
    <BrowserRouter>
      <React.Suspense fallback={loading}>
        <Switch>
          <Route
            path="/"
            history={history}
            name="Home"
            render={(props) => <TheLayout {...props} />}
          />
        </Switch>
      </React.Suspense>
    </BrowserRouter>
  );
};

export default App;
